export default __webpack_public_path__ + "static/nclima-f60d519d727db814f61654ea22e39a44.mp4";